import { TourStatusForZcheduler } from '@zg-rentals/ts-z-calendar-client';
import { useZCalendarWebApiHandler_getTourForSatelliteConversationId } from '@zg-rentals/ts-z-calendar-client-react-query';
import { useContext } from 'react';
import { Box, Paragraph, Tag } from '@zillow/constellation-10';
import TourStatusCard from '../../TourStatusCard';
import { LeadManagementContext } from '../../../contexts/LeadManagementContextProvider';
import { useCachedLeadByConversationId } from '../../../hooks/useLeadManagementTableQuery';

type RenterDetailsTourProps = {
  leadId?: string | null;
};

export default function RenterDetailsTour({ leadId }: RenterDetailsTourProps) {
  const { conversationId } = useContext(LeadManagementContext);
  const lead = useCachedLeadByConversationId(conversationId);
  const listingAlias = lead?.listingDetails?.listingAlias ?? '';

  const { data: tourData, isLoading } = useZCalendarWebApiHandler_getTourForSatelliteConversationId(
    {
      conversationId,
      listingAlias,
    },
    {
      meta: {
        tags: ['zcalendar:tours'],
        context: {
          api: 'getTourForSatelliteConversationId',
          details: 'RenterDetailsTour - Error fetching tour for conversationId',
        },
      },
    },
  );

  if (!isLoading && !tourData?.tour) return null;

  const isTourRequested = tourData?.tour?.tourStatus === TourStatusForZcheduler.REQUESTED;

  return (
    <>
      <Box
        css={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 'tighter',
          marginTop: 'loose',
          marginBottom: 'default',
        }}
      >
        <Paragraph textStyle="body-sm-bold">Tour</Paragraph>
        {isTourRequested && (
          <Tag size="sm" tone="warning">
            Action needed
          </Tag>
        )}
      </Box>
      <TourStatusCard
        conversationId={conversationId}
        leadId={leadId}
        listingAlias={listingAlias}
        renterName={lead?.renterInfo?.renterName ?? ''}
      />
    </>
  );
}
